__turbopack_context__.v({
  "body": "index-module__AflufW__body",
});
